const ITEMS = ["AdBlue — Diesel Exhaust Fluid", "Tata", "Gulf", "Eicher", "BharatBenz", "Bulk Supply", "Dealer Network", "Haldia · West Bengal"];

export default function Marquee({ dark = true }) {
  const row = [...ITEMS, ...ITEMS];
  return (
    <section
      data-testid="editorial-marquee"
      className={`relative overflow-hidden border-y py-8 md:py-10 ${dark ? "bg-navy-deep border-white/10" : "bg-white border-navy/10"}`}
      aria-label="Brands and services"
    >
      <div className="flex w-max animate-marquee whitespace-nowrap">
        {row.map((t, i) => (
          <span key={i} className="flex items-center">
            <span
              className={`font-display text-5xl md:text-7xl font-extrabold uppercase tracking-tight px-8 ${
                i % 2 ? (dark ? "text-outline" : "text-outline-navy") : dark ? "text-white" : "text-navy"
              }`}
            >
              {t}
            </span>
            <span className="h-3 w-3 rotate-45 bg-brand" />
          </span>
        ))}
      </div>
    </section>
  );
}
